import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const ThinArrowRightIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 6.5L15 12L9.5 17.5" stroke="currentColor"/>
    </svg>
)
const ThinArrowRightIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ThinArrowRightIconSvg}
    </SvgIcon>
);
export default ThinArrowRightIcon
